import type { CSSObject } from "type/tss";

export const styles = () => {
	return {
		formControl: {
			width: "100%",
		},
	} satisfies Record<string, CSSObject>;
};
